import { FC } from "react";
import { TAlertAssetProps } from "./Alert.config";
import { Icon, Image } from "../../primitives";
import { AlertAssetWrapper } from "./AlertAssetWrapper";
import { isAlertAssetIconKey, isAlertAssetImage } from "./Alert.guards";

export const AlertAsset: FC<TAlertAssetProps> = ({ asset }) => (
  <AlertAssetWrapper asset={asset}>
    { (asset && isAlertAssetIconKey(asset)) ? (
      <Icon
        className="shrink-0"
        icon={asset}
        size="sm"
      />
    ) : null }
    { (asset && isAlertAssetImage(asset)) ? (
      <Image
        {...asset}
      />
    ) : null }
  </AlertAssetWrapper>
);
